import axios from 'axios';

export const setupAxiosInterceptors = (setLoading) => {
    let activeRequests = 0;
    
    // Show loader on request start
    axios.interceptors.request.use(
        (config) => {            
            if (!config.url.includes("usps.com")) {
                activeRequests += 1; // Increment counter for each request
                if (activeRequests === 1) {
                    setLoading(true);
                }
            }
            return config;
        },
        (error) => {
            setLoading(false);
            return Promise.reject(error);
        }
    );

    // Hide loader on response or error
    axios.interceptors.response.use(
        (response) => {
            if (!response.config.url.includes("usps.com")) { 
                activeRequests -= 1; 
                if (activeRequests === 0) {
                    setLoading(false); 
                }
            }
            return response;
        },
        (error) => {
            activeRequests -= 1; 
            if (activeRequests === 0) {
                setLoading(false); 
            }
            return Promise.reject(error);
        }
    );
};